import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    Collapse
} from '@mui/material';
import { School, ExpandMore, ExpandLess } from '@mui/icons-material';
import PropTypes from 'prop-types';
import WritingPractice from './WritingPractice';
import SpeakingPractice from './SpeakingPractice';

const PracticeWidget = ({ 
    contentType, 
    contentId,
    defaultExpanded = false 
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const handleAICheck = async (type, data) => {
        // Dummy AI check - in real implementation, this would call an API
        alert(`AI Tekshiruvi (${type}):\n\nBu xususiyat sizning ${type === 'Writing' ? 'yozishingizni' : 'nutqingizni'} tahlil qiladi va fikr-mulohaza beradi. (Hozircha demo versiya)`);
    };

    if (!contentType || !contentId) {
        return null;
    }

    return (
        <Paper 
            elevation={3} 
            sx={{ 
                mb: 3,
                overflow: 'hidden',
                borderRadius: 2
            }}
        >
            {/* Header with toggle button */}
            <Box 
                sx={{ 
                    p: 2, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    cursor: 'pointer'
                }}
                onClick={() => setExpanded(!expanded)}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <School />
                    <Typography variant="h6" fontWeight="bold">
                        Mashq Qilish
                    </Typography>
                </Box>
                <Button 
                    color="inherit" 
                    endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
                    sx={{ minWidth: 'auto' }}
                >
                    {expanded ? 'Yopish' : 'Ochish'}
                </Button>
            </Box>

            {/* Collapsible content */}
            <Collapse in={expanded}>
                <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Quyidagi mashqlar orqali o'z yozish va gapirish ko'nikmalaringizni rivojlantiring.
                        Sizning natijalaringiz saqlanadi va keyin qaytadan ko'rishingiz mumkin.
                    </Typography>

                    <WritingPractice
                        contentType={contentType}
                        contentId={contentId}
                        onAICheck={handleAICheck}
                    />

                    <SpeakingPractice
                        contentType={contentType}
                        contentId={contentId}
                        onAICheck={handleAICheck}
                    />
                </Box>
            </Collapse>
        </Paper>
    );
};

PracticeWidget.propTypes = {
    contentType: PropTypes.oneOf([
        'ContentShortStory', 
        'ContentLongPost', 
        'ContentVideoPost', 
        'AlgorithmicProblem'
    ]).isRequired,
    contentId: PropTypes.string.isRequired,
    defaultExpanded: PropTypes.bool
};

export default PracticeWidget;
